// Constantes dos Termos de Uso.
// Quando alterar o texto em src/pages/Terms.tsx, incremente TERMS_VERSION
// (versionamento independente da Política de Privacidade — os dois documentos
// mudam por motivos diferentes). Diferente da privacidade, os Termos NÃO estão
// atrelados ao ConsentService.currentVersion do mobile hoje; se um dia o app
// passar a exigir aceite versionado dos Termos, alinhar os dois aqui.
// 12/08: e-mail de contato pro domínio .com.br — o .app não tem MX e o
// endereço publicado não recebia mensagem. A nota equivalente da privacidade
// migrou pro comentário de versão em `landing/public/privacidade/index.html`
// (o `privacy.ts` que ficava aqui do lado foi removido em 02/09/2026, quando a
// política virou HTML estático na landing).
//
// ⚠️ Os Termos seguem sendo renderizados por `Terms.tsx`, ou seja, com o MESMO
// defeito que tirou a política daqui: o servidor entrega `<div id="root">` e o
// texto só nasce depois do JS. Hoje não morde porque nenhuma loja varre esta
// URL. No dia em que uma varrer — ou em que alguém precisar que o Google indexe
// os Termos — o conserto é o mesmo: HTML estático na landing, redirect aqui.
export const TERMS_VERSION = '2026-07-28.1';
export const TERMS_LAST_UPDATED = '12 de agosto de 2026';
